<h2>Registration Search</h2>
<fieldset>
    <div class="row">
        <div class="col-sm-4 mvd_form-group">
            <label>Registration Number</label>
            <div class="search--input">
                <input class="mvd_form-control autocomplete" id="search" type="number" placeholder="Search by: Number" autocomplete="off" (keyup.enter)="registrationSearchClicked()" [(ngModel)]="registrationSearchString" />
                <button class="search__icon" title="Search" type="button" (click)="registrationSearchClicked()"></button>
            </div>
        </div>
        
    </div>
</fieldset>

<div class="well__footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="resetSearch();">Reset</button>
    </div>
</div>


<h2 *ngIf="registration"> Vehicle Information </h2>
<table class="mvd_table--primeng" *ngIf="registration">
    <thead>
        <tr>
            <th>VIN</th>
            <th>VIN Type</th>
            <th>Vehicle Type</th>
            <th>Year</th>
            <th>Make</th>
            <th>Model</th>
            <th>IRP</th>
        </tr>
    </thead>
    <tbody *ngIf="vehicle">
        <tr>
            <td><a class="list__link" href="javascript:void(0);" (click)="onVehicleClicked(vehicle)">{{vehicle.vin}}</a></td>
            <td>{{vehicle.vinTypeID | displayValue:vinTypes}}</td>
            <td>{{vehicle.vehicleTypeID | displayValue:vehicleTypes}}</td>
            <td>{{vehicle.modelYear}}</td>
            <td>{{vehicle.makeDisplayValue }}</td>
            <td>{{vehicle.modelDisplayValue}}</td>
            <td>{{vehicle.isApportioned | yesNo}}</td>
        </tr>
        <tr>
            <th>Body Style</th>
            <th>Fuel Type</th>
            <th>Factory List Price</th>
            <th>First Registered</th>
            <th>Tonnage</th>
            <th>Unladen Weight</th>
            <th>Axles</th>
        </tr>
        <tr *ngIf="vehicle">
            <td>{{vehicle.bodyStyleTypeID | displayValue:bodyStyleTypes}}</td>
            <td>{{vehicle.fuelTypeID | displayValue:fuelTypes}}</td>
            <td>{{vehicle.factoryListPrice | currency:'USD':'symbol-narrow'}}</td>
            <td><ng-container *ngIf="vehicle.monthFirstRegistered">{{vehicle.monthFirstRegistered | number:'2.0-0'}}/{{vehicle.yearFirstRegistered}}</ng-container></td>
            <td>{{vehicle.tonnageRatingTypeID | displayValue:tonnageRatingTypes}}</td>
            <td>{{vehicle.unladenWeight}}</td>
            <td>{{vehicle.axles}}</td>
        </tr>
    </tbody>
</table>

<h2 *ngIf="registration">
    Registration
</h2>
<table class="mvd_table--primeng" *ngIf="registration && vehicle">
    <thead>
        <tr>
            <th>First Registered</th>
            <th>Effective Date</th>
            <th>Expiration Date</th>
            <th>Status</th>
            <th>Registration Use</th>
            <th>Registration Type</th>
            <th>Perm Reg Date</th>
        </tr>
    </thead>
    <tbody>
        
        <tr>
            <td><ng-container>{{vehicle.monthFirstRegistered | number:'2.0-0'}}/{{vehicle.yearFirstRegistered}}</ng-container></td>
            <td>{{registration.registrationStartDate | shortDate}}</td>
            <td>{{registration.registrationEndDate | shortDate}}</td>
            <td>{{registration.registrationStatusTypeID | displayValue:registrationStatusTypes}} <ng-container *ngIf="registration?.isRestricted">(Restricted)</ng-container></td>
            <td>{{registration.registrationUseTypeID | displayValue:registrationUseTypes}}</td>
            <td>{{registration.registrationTypeID | displayValue:registrationTypes}}</td>
            <td>{{vehicle?.permanentRegistrationDate | shortDate}}</td>
        </tr>
        
    </tbody>
    
</table>

<h2 class="mvd_alert--label" *ngIf="hasSearched && !registration">
    No Results
</h2>


